import React, { FC } from 'react'
import { NotiProvider } from '@notify/NotiContext'

const DefaultLayout: FC = ({ children }) => {
  return <NotiProvider>{children}</NotiProvider>
}

export default DefaultLayout
